import classNames from "classnames";
import { useState } from "react";
import Icon from "./icon";

const AccordionBox = ({ onEdit, title, editLabel, readOnly, defaultOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);

  const handleAccordion = () => setOpen((current) => !current);

  return (
    <div className={classNames("box-wrapper__box", open && "box-wrapper__box--open")}>
      <div className="box-wrapper__box-header">
        <button className="box-wrapper__btn" onClick={handleAccordion}>
          <div className="box-wrapper__caption">{title}</div>
          <Icon name="chevron" />
        </button>
      </div>
      <div className="box-wrapper__profile">{children}</div>
      {!readOnly && (
        <button type="button" className="link link--accent" onClick={onEdit}>
          <Icon name="pencil" />
          {editLabel}
        </button>
      )}
    </div>
  );
};

export default AccordionBox;
